import React, { useState, useEffect, useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { Col, Row } from 'react-bootstrap';
import Editor from 'components/editor/Editor';

interface CharCountProps {
  maxLength: number;
  inputName: string;
  register: any;
  errors: any;
  label: string;
  fieldDescription?: string;
  defaultValue?: string;
  placeholder?: string;
  styledText?: boolean;
  control?: any;
  setValue?: (name: string, value: any) => void;
}

const CharCountInput: React.FC<CharCountProps> = ({
  maxLength,
  inputName,
  register,
  errors,
  label,
  control,
  fieldDescription = '',
  defaultValue = '',
  placeholder = '',
  styledText = false,
  setValue,
}) => {
  const [charCount, setCharCount] = useState(maxLength - (defaultValue || '').length);

  useEffect(() => {
    setCharCount(maxLength - (defaultValue || '').length);
  }, [maxLength, defaultValue]);

  const handleInputChange = useCallback((value: string) => {
    const inputLength = value.length;
    if (inputLength <= maxLength) {
      setCharCount(maxLength - inputLength);
      setValue?.(inputName, value);
    }
  }, [maxLength, inputName, setValue]);

  return (
    <Row>
      <Col md={{ span: 3, offset: 0 }}>
        <label>{label}</label>
        {fieldDescription && <p className="field-description">{fieldDescription}</p>}
      </Col>
      <Col md={{ span: 9, offset: 0 }}>
        {errors[inputName] && <span>This field is required</span>}
        {styledText ? (
          <Controller
            name={inputName}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
              <Editor
                key={inputName}
                defaultValue={field.value || ''}
                placeholder={placeholder}
                onChange={(value) => {
                  field.onChange(value);
                  handleInputChange(value);
                }}
              />
            )}
          />
        ) : (
          <textarea
            {...register(inputName)}
            className="col-md-9"
            placeholder={placeholder}
            maxLength={maxLength}
            onChange={(e) => handleInputChange(e.target.value)}
            defaultValue={defaultValue}
          />
        )}
        <i>{charCount} Characters Remaining</i>
        <div className="char-count bio-chars-left"></div>
      </Col>
    </Row>
  );
};

export default CharCountInput;